import { useRef, useEffect, useState } from 'react';
import { RichTextEditor } from 'lexical-react-rte';

interface LexicalEditorProps {
    initialHtml?: string;
    onChange: (html: string) => void;
    placeholder?: string;
}

export function LexicalEditor({ initialHtml = '', onChange, placeholder }: LexicalEditorProps) {
    const editorRef = useRef<any>(null);
    const [htmlContent, setHtmlContent] = useState(initialHtml);

    // Provide a small wrapper onChange to extract HTML and pass it up
    const handleChange = () => {
        if (editorRef.current) {
            const currentHtml = editorRef.current.getHTML();
            if (currentHtml !== htmlContent) {
                setHtmlContent(currentHtml);
                onChange(currentHtml);
            }
        }
    };

    return (
        <div className="relative lexical-rte-container">
            <style>{`
                .lexical-rte-container .lexical-react-rte {
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                }
                .lexical-rte-container .lexical-react-rte-toolbar {
                    border-bottom: 1px solid #e5e7eb;
                    background-color: #f9fafb;
                }
                .lexical-rte-container .lexical-react-rte-content {
                    flex: 1;
                    padding: 1rem;
                    outline: none;
                    min-height: 250px;
                }
            `}</style>
            <RichTextEditor
                ref={editorRef}
                initialValue={initialHtml}
                onChange={handleChange}
                placeholder={placeholder}
                autoFocus={false}
            />
        </div>
    );
}
